export const REGISTER_REQUEST= 'REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';

export const LOGIN_REQUEST= 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';

export const LOGOUT_REQUEST= 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAIL = 'LOGOUT_FAIL';

export const SET_USER = 'SET_USER';

export const GOOGLE_SIGN_IN_REQUEST= 'GOOGLE_SIGN_IN_REQUEST';
export const GOOGLE_SIGN_IN_SUCCESS = 'GOOGLE_SIGN_IN_SUCCESS';
export const GOOGLE_SIGN_IN_FAIL = 'GOOGLE_SIGN_IN_FAIL';

export const FB_SIGN_IN_REQUEST= 'FB_SIGN_IN_REQUEST';
export const FB_SIGN_IN_SUCCESS = 'FB_SIGN_IN_SUCCESS';
export const FB_SIGN_IN_FAIL = 'FB_SIGN_IN_FAIL';
